import { Injectable } from '@angular/core';
import { ProfileGroup } from 'src/app/interfaces/profile-group';
import { APIProviderService } from '../api/api.provider.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileGroupsProviderService extends APIProviderService<ProfileGroup> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/FormGroups`;
  }
}
